<template>
  <div class="ma-4">
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />
    <div class="text-h4 mb-2" v-show="!showSkeleton">Atualizar Fila - {{ description }}</div>

    <div v-if="canRender">
      <CadastroFila edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import filasStore from '../_store'

import CadastroFila from './CadastroFila'

export default {
  name: 'AtualizarFila',
  props: {
    _id: String,
  },
  components: { CadastroFila, SkeletonLoaderTitleUpdate },
  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),
  computed: {
    ...mapGetters('atualizarFilaModuleCallCenterStore', ['getFila']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarFilaModuleCallCenterStore', filasStore)
    await this.listarFilaEspecifica(this._id)
    this.description = this.getFila.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarFilaModuleCallCenterStore', ['listarFilaEspecifica']),
  },
}
</script>
